<template>
  <!-- This page contains the real life tiimi teams that are in this league -->
  <v-sheet class="pa-4">
    <div class="d-flex justify-end">
      <v-btn @click="creating_new = true" small outlined>
        Add team
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
    <v-sheet style="border-left: 3px solid lightgrey; color: grey;" class="pl-4">
      League teams are the ePesis user teams that have been added to the league
    </v-sheet>
    <!-- <v-sheet class="d-flex justify-end">
      <v-btn class="mb-4" outlined small>
        <v-icon>mdi-plus</v-icon>
        Add team
      </v-btn>
    </v-sheet> -->
    <LeagueTeam
      class="mt-2"
      v-for="team in teams"
      :key="team.id"
      :team="team"
    ></LeagueTeam>
    <v-dialog max-width="600" v-model="creating_new">
      <v-card class="pt-4">
        <v-card-text>
          <v-text-field
            v-model="new_team.team_name"
            label="Nimi"
          ></v-text-field>
          <v-text-field
            v-model="new_team.initial_admin"
            label="Eka admin"
          ></v-text-field>
          <v-select
            clearable
            label="IRL seura"
            :items="clubs"
            item-text="club_name"
            item-value="id"
            v-model="new_team.league_club_id"
          ></v-select>
          <v-select
            label="Plääni"
            clearable
            v-model="new_team.plan_id"
            :items="plans"
            item-text="full_name"
            item-value="id"
          >
            <template v-slot:selection="{ item }">
              <LeagueTeamPlan :item="item"></LeagueTeamPlan>
            </template>
            <template v-slot:item="{ item }">
              <LeagueTeamPlan :item="item"></LeagueTeamPlan>
            </template>
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined @click="creating_new = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn outlined color="primary" @click="createNew">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import LeagueTeam from '@/components/tiimi_admin/league/team/LeagueTeam.vue'
import LeagueTeamPlan from '@/components/tiimi_admin/league/team/LeagueTeamPlan.vue'

export default {
  data: () => ({
    show: false,
    creating_new: false,
    new_team: null,
    empty_data: {
      team_name: '',
      league_id: null,
      sport_id: 'pesapallo',
      plan_id: null,
      initial_admin: '',
      league_club_id: null,
      dont_add_user: true
    }
  }),
  components: { LeagueTeam, LeagueTeamPlan },
  created() {
    this.new_team = { ...this.empty_data }
    this.initClubs(this.$route.params.league_id)
    this.initTeams(this.$route.params.league_id)
    this.initPlans()
  },
  methods: {
    ...mapActions('admin', [
      'initTeams',
      'initClubs'
    ]),
    ...mapActions('noti', ['success', 'error']),
    ...mapMutations('admin', [
      'ADD_LEAGUE_TEAM'
    ]),
    ...mapActions('auth', [
      'initPlans'
    ]),
    ...mapActions('team', [
      'createTeam'
    ]),
    ...mapActions('noti', [
      'success'
    ]),
    createNew() {
      this.createTeam({
        ...this.new_team,
        league_id: this.$route.params.league_id,
        dont_add_user: true
      })
        .then(() => {
          this.ADD_LEAGUE_TEAM(this.new_team)
          this.new_team = { ...this.empty_data }
          this.creating_new = false
          this.success('RAHAAAAAAA')
        })
        .catch(e => {
          alert(e)
        })
    }
  },
  computed: {
    ...mapGetters('admin', [
      'teams',
      'clubs',
    ]),
    ...mapGetters('auth', [
      'plans'
    ])
  }
}
</script>